export default "__VITE_ASSET__BX4P194B__"